import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import ConfirmModal from '@/components/modals/confirm-modal/confirm-modal.vue'
import IcMenu from '@/assets/svg/ic-menu.svg?inline'
import IcExit from '@/assets/svg/ic-exit.svg?inline'
import IcMenuExit from '@/assets/svg/ic-menu-exit.svg?inline'
import IcDoc from '@/assets/svg/ic-doc.svg?inline'
import { routes } from '@/router'
import { superUsers } from '@/const'
import { managersPages, topManagersPages } from '@/const'
import { MANAGERS_ROLES, TOP_MANAGERS_ROLES } from '@/const/super-users'

const updateTime = 10000

export default {
  name: 'Menu',
  components: {
    ConfirmModal,
    IcMenu,
    IcExit,
    IcMenuExit,
    IcDoc
  },
  static() {
    return {
      superUsers
    }
  },
  data() {
    return {
      open: false,
      routeList: routes.filter(routeObj => routeObj.inMenu),
      ready_courier: null,
      timeoutUpdate: null,
    }
  },
  computed: {
    ...mapState({
      user: state => state.users.user,
      acceptRouteTasks: state => state.collectOrders.acceptRouteTasks,
      selectedCity: state => state.manufactures.selectedCity,
    }),
    ...mapGetters({
      actionTasksCount: 'collectOrders/actionTasksCount'
    }),
    routerListPermission() {
      if (this.user) {
        /**
         * если пользователь не менеджер и не топ-менеджер,
         * то убираем и managersPages и topManagersPages
         */
        if (![...MANAGERS_ROLES, ...TOP_MANAGERS_ROLES].includes(this.user.role)) {
          return this.routeList.filter(route => ![...managersPages, ...topManagersPages].includes(route.name))
        }
        /**
         * если пользователь не менеджер, НО не топ-менеджер,
         * то убираем topManagersPages
         */
        if (!TOP_MANAGERS_ROLES.includes(this.user.role)) {
          return this.routeList.filter(route => ![...topManagersPages].includes(route.name))
        }
      }
      return this.routeList
    },
  },
  methods: {
    ...mapMutations({
      setSelectedCity: 'manufactures/SET_SELECTED_CITY',
      setSelectedAreas: 'manufactures/SET_SELECTED_AREAS',
      setSelectedManufacture: 'manufactures/SET_SELECTED_MANUFACTURE',
      removeUserManufacture: 'users/REMOVE_USER_MANUFACTURE',
      setLoading: 'pageLoader/SET_LOADING',
    }),
    ...mapActions({
      fixateShift: 'users/fixateShift',
      getShifts: 'couriers/getShifts',
    }),
    beforeFixateShift() {
      this.$refs['confirm-modal'].show()
    },
    async onFixateShift() {
      await this.fixateShift()
      this.setSelectedCity(null)
      this.setSelectedAreas([])
      this.setSelectedManufacture(null)
      
      this.removeUserManufacture()
      this.$router.push({
        name: 'welcome-screen'
      })
    },
    async getShiftsInfo() {
      this.getShifts().then(res => this.ready_courier = res.ready.length);
    },
    async setShiftInfo() {
      try {
        this.setLoading(true)
        await this.getShiftsInfo()
        this.timeoutUpdate = setTimeout(() => {
          this.updateInfo()
        }, updateTime)
      } finally {
        this.setLoading(false)
      }

    },
    async updateInfo() {
      if (this._isDestroyed || this._isBeingDestroyed) {
        return;
      }
      await this.getShiftsInfo()
      this.timeoutUpdate = setTimeout(() => {
        this.updateInfo()
      }, updateTime)
    },
  },
  mounted() {
    this.updateInfo();
  },
  beforeDestroy() {
    clearTimeout(this.timeoutUpdate);
  },
}